import { render, staticRenderFns } from "./TextButtonWithCaret.vue?vue&type=template&id=f1cf9934&scoped=true&"
import script from "./TextButtonWithCaret.vue?vue&type=script&lang=js&"
export * from "./TextButtonWithCaret.vue?vue&type=script&lang=js&"
import style0 from "./TextButtonWithCaret.vue?vue&type=style&index=0&id=f1cf9934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cf9934",
  null
  
)

export default component.exports